var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCimasLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 617.18 517.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #888583;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: #297cc0;\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 617.18,
    height: 517.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.75,184.54c-16.8,0-30.55,13.75-30.55,30.55v86.33c0,16.8,13.75,30.54,30.55,30.54h365.01c16.81,0,30.55-13.75,30.55-30.54v-86.33c0-16.8-13.74-30.55-30.55-30.55H37.75Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.9,
    y1: 661.95,
    x2: 36.05,
    y2: 661.95,
    gradientTransform: "translate(19173.22 1216.79) rotate(-90) scale(28.63 -28.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#888584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#888584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8a8786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#918f8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#9f9c9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#b2afae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#cac7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e4e4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 617.18,
    height: 517.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.43,7.2c-16.8,0-30.54,13.75-30.54,30.55v86.33c0,16.8,13.75,30.55,30.54,30.55h86.33c16.81,0,30.55-13.75,30.55-30.55V37.75c0-16.8-13.74-30.55-30.55-30.55h-86.33Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.89,
    y1: 658.03,
    x2: 41.04,
    y2: 658.03,
    gradientTransform: "translate(19200.29 1182.35) rotate(-90) scale(28.63 -28.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#277bc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#277bc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#3a85c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6c9fd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6c7e8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 617.18,
    height: 517.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M493.1,184.54c-16.8,0-30.55,13.75-30.55,30.55v86.33c0,16.8,13.75,30.54,30.55,30.54h86.33c16.81,0,30.55-13.75,30.55-30.54v-86.33c0-16.8-13.74-30.55-30.55-30.55h-86.33Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 30.9,
    y1: 653.06,
    x2: 36.05,
    y2: 653.06,
    gradientTransform: "translate(19234.6 1216.79) rotate(-90) scale(28.63 -28.63)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 617.18,
    height: 517.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.43,362.38c-16.8,0-30.54,13.75-30.54,30.54v86.33c0,16.8,13.75,30.55,30.54,30.55h86.33c16.81,0,30.55-13.75,30.55-30.55v-86.33c0-16.8-13.74-30.54-30.55-30.54h-86.33Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 25.9,
    x2: 31.05,
    gradientTransform: "translate(19200.29 1251.33) rotate(-90) scale(28.63 -28.63)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 617.18,
    height: 517.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M402.76,177.34H37.76c-20.82,0-37.76,16.93-37.76,37.76v86.33c0,20.82,16.94,37.76,37.76,37.76h365.01c20.82,0,37.76-16.94,37.76-37.76v-86.33c0-20.82-16.94-37.76-37.76-37.76"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.2,
    y: 184.54,
    width: 426.1,
    height: 147.42
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.15,243.22c-10.7-.54-17.89,8.17-17.89,18.88s7.18,18.88,17.89,18.88c9.35,0,13.81-5.36,16.26-9.91h22.9c-4.06,16.86-19.1,30.65-39.43,30.65-22.76,0-40.24-17.67-40.24-39.75s17.21-39.49,39.7-39.49c19.92,0,36.04,12.99,39.83,31.19h-22.76c-2.44-5.09-6.91-10.44-16.26-10.44M113.5,225.01h22.49v74.29h-22.49v-74.29ZM113.5,200.25h22.49v16.87h-22.49v-16.87ZM237.06,299.31v-39.49c0-6.03,0-16.47-11.52-16.47-12.47,0-12.47,11.25-12.47,15.4v40.56h-22.49v-40.43c0-4.02,0-15.53-11.25-15.53-12.73,0-12.73,12.05-12.73,16.47v39.49h-22.49v-74.3h21v7.9h.27c1.76-3.08,6.64-10.44,20.73-10.44,6.64,0,15.71,2.28,21.68,13.25,4.61-7.23,12.33-13.25,23.84-13.25,5.28,0,13.69,1.2,19.78,7.5,7.04,7.36,8.13,12.32,8.13,28.78v40.56h-22.49ZM323.77,299.31v-8.04h-.27c-3.79,7.23-13.15,10.58-21.95,10.58-23.85,0-37.8-18.47-37.8-39.75,0-24.36,17.75-39.63,37.8-39.63,12.33,0,19.24,5.89,21.95,10.44h.27v-7.9h22.49v74.3h-22.49ZM304.8,243.22c-12.87,0-18.56,10.7-18.56,19.14,0,6.96,5.15,18.74,18.7,18.74s18.83-11.78,18.83-19.01c0-8.97-6.23-18.88-18.97-18.88M379.45,240.27c-4.74,0-6.37,2.95-6.37,4.95,0,4.02,5.56,6.29,11.52,8.03,12.74,3.48,26.29,7.23,26.29,23.29s-13.95,25.3-30.62,25.3c-11.38,0-28.59-5.08-30.62-24.63h22.36c.95,6.83,7.59,6.83,8.54,6.83,3.79,0,7.86-2.15,7.86-5.76,0-5.76-5.56-6.43-19.92-11.91-9.76-3.08-17.89-9.37-17.89-19.41,0-14.73,13.55-24.5,29.13-24.5,9.89,0,26.96,3.88,28.85,23.43h-22.08c-.14-1.61-.41-5.62-7.05-5.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.76,0h-86.33c-20.82,0-37.76,16.93-37.76,37.76v86.33c0,20.82,16.94,37.76,37.76,37.76h86.33c20.82,0,37.76-16.94,37.76-37.76V37.76c0-20.82-16.94-37.76-37.76-37.76"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 285.89,
    y: 7.2,
    width: 147.42,
    height: 147.43
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M579.42,177.34h-86.33c-20.82,0-37.76,16.93-37.76,37.76v86.33c0,20.82,16.93,37.76,37.76,37.76h86.33c20.82,0,37.76-16.94,37.76-37.76v-86.33c0-20.82-16.94-37.76-37.76-37.76"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 462.55,
    y: 184.54,
    width: 147.42,
    height: 147.42
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M402.76,355.17h-86.33c-20.82,0-37.76,16.93-37.76,37.75v86.33c0,20.82,16.94,37.76,37.76,37.76h86.33c20.82,0,37.76-16.94,37.76-37.76v-86.33c0-20.82-16.94-37.75-37.76-37.75"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 285.89,
    y: 362.38,
    width: 147.42,
    height: 147.42
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M470.82,128.94c2.66,0,5.26.68,7.81,2.05,2.54,1.37,4.52,3.33,5.93,5.87,1.42,2.55,2.12,5.2,2.12,7.96s-.7,5.37-2.09,7.89c-1.4,2.52-3.35,4.48-5.87,5.88s-5.15,2.09-7.9,2.09-5.38-.7-7.9-2.09c-2.51-1.4-4.47-3.36-5.87-5.88-1.41-2.52-2.11-5.15-2.11-7.89s.71-5.41,2.14-7.96c1.42-2.54,3.4-4.5,5.94-5.87,2.54-1.36,5.14-2.05,7.8-2.05M470.82,131.57c-2.23,0-4.4.57-6.51,1.71-2.11,1.14-3.76,2.78-4.95,4.9-1.19,2.12-1.79,4.34-1.79,6.63s.58,4.48,1.76,6.58c1.17,2.1,2.81,3.73,4.91,4.9,2.11,1.17,4.3,1.76,6.59,1.76s4.48-.59,6.59-1.76c2.1-1.17,3.74-2.81,4.9-4.9,1.16-2.1,1.75-4.29,1.75-6.58s-.6-4.51-1.78-6.63c-1.18-2.13-2.83-3.76-4.95-4.9-2.12-1.14-4.28-1.71-6.5-1.71M463.86,153.59v-17.08h5.87c2,0,3.45.16,4.36.47.9.31,1.61.87,2.14,1.65.53.79.8,1.62.8,2.5,0,1.25-.45,2.34-1.33,3.26-.89.92-2.08,1.44-3.54,1.55.6.25,1.08.55,1.45.91.68.67,1.53,1.8,2.53,3.38l2.08,3.35h-3.37l-1.51-2.69c-1.19-2.12-2.15-3.44-2.88-3.98-.5-.39-1.24-.59-2.21-.59h-1.62v7.25h-2.75ZM466.61,143.98h3.35c1.6,0,2.69-.24,3.27-.72s.87-1.11.87-1.89c0-.5-.13-.96-.42-1.35-.28-.4-.67-.7-1.17-.9-.5-.2-1.42-.29-2.77-.29h-3.13v5.15Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimasLogo);
export default __webpack_public_path__ + "static/media/Cimas-Logo.ffca0dbf6a176081474d6d98985dc840.svg";
export { ForwardRef as ReactComponent };